module.exports = __webpack_public_path__ + "img/black-bar.29b4d911.svg";